export const API_URL = 'https://api-esero.cerebriti.com/esero/stats'